
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  PS_Get_Buttons_Result.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\PS_Get_Buttons_Result.ts

export class PS_Get_Buttons_Result {

  // int CurrentStatutId
  public CurrentStatutId: number=0;

  // string CurrentStatutCod
  public CurrentStatutCod?: string=null;

  // string StatutCod
  public StatutCod?: string=null;

  // int? StatutId
  public StatutId?: number=null;

  // string BtnLib
  public BtnLib?: string=null;

  // string BtnClass
  public BtnClass?: string=null;

  // string MailCod
  public MailCod?: string=null;

  // int? ExitScreen
  public ExitScreen?: number=null;

  // int? IsValidationBtn
  public IsValidationBtn?: number=null;

  // int? IsRefusBtn
  public IsRefusBtn?: number=null;

  // int? IsProspectBtn
  public IsProspectBtn?: number=null;

  // int? IsRetourFouBtn
  public IsRetourFouBtn?: number=null;

  // int? IsRetourAchatBtn
  public IsRetourAchatBtn?: number=null;

  // int? IsPriseEnChargeBtn
  public IsPriseEnChargeBtn?: number=null;

  // int? IsMiseEnAttenteBtn
  public IsMiseEnAttenteBtn?: number=null;

  // int? StatutIdPrec
  public StatutIdPrec?: number=null;

  // string StatutCodPrec
  public StatutCodPrec?: string=null;

  // int? CommentsRequired
  public CommentsRequired?: number=null;

  // int? IsSuspensionBtn
  public IsSuspensionBtn?: number=null;

  // int? IsReactivationBtn
  public IsReactivationBtn?: number=null;
}